module.exports = __webpack_public_path__ + "img/sweatshirts_fleece.5e24234b.svg";